export default __webpack_public_path__ + "static/media/etherreap.c6114219.png";